(function() {
  const drawer_id = 'shopify-section-drawer-pdp-infos';
  const panelsByKey = new Map();
  let indexed = false;

  function indexPanels(container) {
    if (indexed) return;
    container.querySelectorAll('[data-accordion]').forEach((panel) => {
      panelsByKey.set(panel.dataset.accordion, panel);
      panel.remove();
    });
    indexed = true;
  }

  document.addEventListener('drawer:opened', function(e) {
    if (e.detail?.drawerId !== drawer_id || !e.detail.target) return;
    const drawer = document.getElementById(drawer_id);
    const container = drawer?.querySelector('[data-drawer-panels]');
    if (!container) return;

    indexPanels(container);
    container.innerHTML = '';

    const targetPanel = panelsByKey.get(e.detail.target);
    if (targetPanel) {
      container.appendChild(targetPanel);

      const heading = drawer.querySelector('.drawer__heading');
      const title = targetPanel.dataset.accordionTitle;
      if (heading && title) {
        heading.textContent = title;
        heading.dataset.accordion = e.detail.target;
      }
    }
  });

  document.addEventListener('drawer:closed', function(e) {
    if (e.detail?.drawerId !== drawer_id) return;
    const drawer = document.getElementById(drawer_id);
    const container = drawer?.querySelector('[data-drawer-panels]');
    if (container) container.innerHTML = '';
  });
})();
